import { SurreyHero } from './components/SurreyHero';
import { EmergingMarket } from './components/EmergingMarket';
import { BylawFramework } from './components/BylawFramework';
import { LicensingRequirements } from './components/LicensingRequirements';
import { EnforcementPolicies } from './components/EnforcementPolicies';
import { MarketOpportunities } from './components/MarketOpportunities';
import { SurreyCTA } from './components/SurreyCTA';
import { Navbar } from '../home/components/Navbar';
import { Footer } from '../home/components/Footer';

export default function SurreySTR() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <SurreyHero />
      <EmergingMarket />
      <BylawFramework />
      <LicensingRequirements />
      <MarketOpportunities />
      <EnforcementPolicies />
      <SurreyCTA />
      <Footer />
    </div>
  );
}
